import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import stylex from '@stylexjs/stylex';
import { createPolymorphicComponent, } from '../../helpers/react/polymorphicComponentTypes';
import { isProduction } from '../../helpers/isProduction';
import { dataProps } from '../../helpers/dataProps';
export const Base = createPolymorphicComponent(forwardRef(function Base(props, forwardedRef) {
    const { as, renderRoot, sx, visualState, ...other } = props;
    const Element = as ?? 'div';
    const childrenProps = {
        ...other,
        ref: forwardedRef,
        ...(typeof Element === 'string' && !renderRoot
            ? { ...stylex.props(sx), ...dataProps(visualState) }
            : { sx, visualState }),
    };
    if (!isProduction()) {
        const propKeys = Object.keys(other);
        if (propKeys.includes('className') || propKeys.includes('style')) {
            // eslint-disable-next-line no-console
            console.error(`sixui: The \`Base\` component does not support \`className\` or \`style\` props.`);
        }
    }
    return renderRoot ? (renderRoot(childrenProps)) : (_jsx(Element, { ...childrenProps }));
}));
